export default __webpack_public_path__ + "static/media/ALLdemos_old.f8961193.jpeg";